import React from 'react';
import { store } from 'reducers';
import { useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@mui/material';
import { Brightness4Outlined, Brightness5Outlined } from '@mui/icons-material';
import { updateDarkmode, DARKMODE } from 'reducers/coreui';
import { enable as enableDarkMode, disable as disableDarkMode, setFetchMethod } from 'darkreader';

const THEME_BARS = [
  { id: 1, name: 'Light Mode', code: 'light' },
  { id: 2, name: 'Dark Mode', code: 'dark' },
];

const handleChangeMode = (isDark) => {
  if (isDark) {
    store.dispatch(updateDarkmode(THEME_BARS[0].code));
    disableDarkMode();
  } else {
    store.dispatch(updateDarkmode(THEME_BARS[1].code));
    setFetchMethod(window.fetch);
    enableDarkMode({ contrast: 90, sepia: 10 });
  }
};

const Darkmode = ({ init }) => {
  const { darkmode } = useSelector(({ coreui }) => coreui);

  const handleClickBar = (isDark) => (event) => {
    handleChangeMode(isDark);
  };

  React.useEffect(() => {
    if (init) {
      const darkmode = THEME_BARS.find((item) => item.code === localStorage.getItem(DARKMODE)) || THEME_BARS[0];
      const isLight = darkmode.code === THEME_BARS[0].code;
      handleChangeMode(isLight);
    }
  }, [init]);

  const themeChoose = THEME_BARS.find((item) => item.code === darkmode) || THEME_BARS[0];
  const isDark = themeChoose.code === THEME_BARS[1].code;
  return (
    <Tooltip title='Toggle Dark Mode'>
      <IconButton onClick={handleClickBar(isDark)}>
        {isDark ? <Brightness4Outlined /> : <Brightness5Outlined className='text-neutral-80' />}
      </IconButton>
    </Tooltip>
  );
};

export default Darkmode;
